import { Shield } from 'lucide-react';
import { Link } from 'react-router-dom';

interface GeneralNavbarProps {
  logo?: string;
}

function GeneralNavbar({ logo }: GeneralNavbarProps): JSX.Element {
  return (
    <nav className="bg-white shadow-sm border-b border-gray-100 py-4 sticky top-0 z-50 backdrop-blur-sm bg-white/95">
      <div className="container mx-auto px-4 py-1">
        <div className="flex items-center justify-between">
          <div className="flex items-center space-x-3">
            <Link to="/">
              <img src="/logo.svg" alt="Fincentive Logo" className="h-5 sm:h-7 w-auto fill-primary" />
            </Link>
            {logo && (
              <div className="hidden md:flex items-center space-x-2">
                <div className="w-px mx-2 h-8 bg-gray-300"></div>
                <img src={logo} alt="Program Logo" className="h-6 w-auto" />
              </div>
            )}
          </div>
          
          <div className="flex items-center space-x-2">
            <div className="hidden md:flex items-center space-x-2 text-sm text-gray-600">
              <Shield className="w-4 h-4 text-green-600" />
              <span>SSL Secured</span>
            </div>
            {logo && (
              <div className="md:hidden">
                <img src={logo} alt="Program Logo" className="h-6 w-auto" />
              </div>
            )}
          </div>
        </div>
      </div>
    </nav>
  );
}

export default GeneralNavbar; 